import { createContext, useContext } from "react";

export const RouteParamsContext = createContext();

export const useRouteParams = () => useContext(RouteParamsContext);